import { SxProps } from '@mui/material';
import { grey10 } from 'app/components/ThemeProvider/colors';
import { getTheme } from '../../ThemeProvider/theme';

const theme = getTheme('light');
export const bg: SxProps = {
  background: grey10,
  width: '74%',
  p: '28px 50px 28px 28px',
  height: 'calc(100vh - 110px)',
  overflow: 'auto',

  [theme.breakpoints.down('md')]: {
    width: '100%',
    p: '28px 36px 28px 28px',
  },
  [theme.breakpoints.down(768)]: {
    p: '28px 28px 28px 28px',
  },
  [theme.breakpoints.down('sm')]: {
    p: '28px 20px 28px 20px',
  },
};

export const bgWithoutData: SxProps = {
  width: '100vw',
  height: '100vh',
  background: grey10,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
};
